import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './scss/resetPassword.scss';
import logo from './images/logo.svg';
import api from './services/apiService';

function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    if (!token) {
      setError('Invalid or missing token');
    }
  }, [location.search]);

  const handleBlur = () => {
    if (password && confirmPassword && password !== confirmPassword) {
      setError('Passwords do not match');
    } else {
      setError('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    const params = new URLSearchParams(location.search);
    const token = params.get('token');

    if (!token) {
      setError('Invalid or missing token');
      return;
    }

    try {
      const response = await api.post(`${process.env.REACT_APP_API_URL}/reset_password.php`, {
        token: token,
        password: password
      });

      const result = response.data;
      if (result.success) {
        setSuccess(true);
        setTimeout(() => {
          navigate('/');
        }, 2000);
      } else {
        setError(result.message || 'Failed to reset password');
      }
    } catch (error) {
      console.error('Error during password reset:', error);
      setError('An error occurred during password reset');
    }
  };

  return (
    <div className="reset-password-container container">
      <div className="logo-container"><img src={logo} alt="Logo" className="logo" /></div>
      <h2 className="audiowide">Reset Password</h2>
      {error ? (
        <div className="error-message">{error}</div>
      ) : success ? (
        <div className="success-message form-group">
          <p>Password has been reset successfully.</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <label>New Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onBlur={handleBlur}
            required
          />
          <label>Confirm Password</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            onBlur={handleBlur}
            required
          />
          <button type="submit">Reset Password</button>
        </form>
      )}
    </div>
  );
}

export default ResetPassword; 